module.exports = __webpack_public_path__ + "static/media/security2.396a2cbf.svg";